
/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import PropTypes from 'prop-types';
export default function IconFilterWithCircle({ className }){
  return(
    <svg className={className} fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" fill="#5E811E" fillOpacity="0.15" r="16"/>
      <path d="M8.25018 9.61C10.5702 12.59 14.0002 17 14.0002 17V22C14.0002 23.1 14.9002 24 16.0002 24C17.1002 24 18.0002 23.1 18.0002 22V17C18.0002 17 21.4302 12.59 23.7502 9.61C24.2602 8.95 23.7902 8 22.9502 8H9.04018C8.21018 8 7.74018 8.95 8.25018 9.61Z" fill="#5E811E"/>
    </svg>
  );
}
IconFilterWithCircle.propTypes = {
  className: PropTypes.string
};
